import { PermitFieldValueInput } from "../../models/globalTypes";
import { DateTemplateField } from "../../models/TemplateField";
import DateTimePicker from "../common/DateTimePicker";

interface Props {
  field: DateTemplateField;
  value: PermitFieldValueInput | undefined;
  onChange: (fieldKey: string, update: Partial<PermitFieldValueInput>) => void;
  disabled: boolean;
  error: string | undefined;
  required?: boolean;
}

const DateFieldInput = ({ field, value, onChange, disabled, error, required }: Props) => {
  // Inverse of the save transform: extract UTC components and construct a local Date
  // so the DateTimePicker displays the same values the user originally selected.
  const dateObj = value?.dateValue
    ? (() => {
        const d = new Date(value.dateValue);
        return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), 0, 0);
      })()
    : undefined;

  const handleChange = (date: Date | undefined) => {
    if (!date) {
      onChange(field.key, { dateValue: null });
      return;
    }
    // Use Date.UTC with local components so the ISO string preserves
    // the user-selected date/time instead of shifting by timezone offset.
    const utc = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0, 0),
    );
    onChange(field.key, { dateValue: utc.toISOString() });
  };

  return (
    <DateTimePicker
      label={field.label}
      value={dateObj}
      onChange={handleChange}
      includeTime={field.includeTime}
      disabled={disabled}
      error={error}
      required={required}
    />
  );
};

export default DateFieldInput;
